
import Photos from '@/components/photos3.vue'
import CategoryHead from '@/components/Title/CategoryHead.vue'
import { defineComponent } from 'vue'
export default defineComponent({
  components: {
    Photos,
    CategoryHead
  }
})
